import { ConferenciaComponent } from './../conferencia/conferencia.component';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-evento-conferencia',
  templateUrl: './evento-conferencia.component.html',
  styleUrls: ['./evento-conferencia.component.scss'],
})
export class EventoConferenciaComponent implements OnInit {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public dialogRefEvento: MatDialogRef<EventoConferenciaComponent>
  ) {}

  ngOnInit(): void {}

  openEConferenciaModal() {
    const dialogRef = this.dialog.open(ConferenciaComponent, {
      width: '700px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
    this.dialogRefEvento.close();
  }
  onCancel(): void {
    this.dialogRefEvento.close();
  }
}
